import { useState, useEffect } from 'react';
import { getFromLocalStorage } from 'utils';
import { SELECTED_SITE_LOCAL_STORAGE_KEY } from 'pages/authenticated/scorecard/consts';

interface Site {
    id: number;
    name: string | null;
}

export const useSelectedSite = () => {
    const [selectedSite, setSelectedSite] = useState<Site | null>(null);

    useEffect(() => {
        // Initial load
        const stored = getFromLocalStorage(SELECTED_SITE_LOCAL_STORAGE_KEY);
        setSelectedSite(stored);

        // Listen for storage changes (when localStorage is updated from other tabs/components)
        const handleStorageChange = (e: StorageEvent) => {
            if (e.key === SELECTED_SITE_LOCAL_STORAGE_KEY) {
                const newValue = e.newValue ? JSON.parse(e.newValue) : null;
                setSelectedSite(newValue);
            }
        };

        // Listen for custom events (when localStorage is updated in the same tab)
        const handleCustomStorageChange = (e: CustomEvent) => {
            if (e.detail.key === SELECTED_SITE_LOCAL_STORAGE_KEY) {
                setSelectedSite(e.detail.value);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('localStorageChange', handleCustomStorageChange as EventListener);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('localStorageChange', handleCustomStorageChange as EventListener);
        };
    }, []);

    return selectedSite;
};
